import React, {Fragment, useState} from "react";
import {Col, Form, Input, Row} from "antd";
import {FormattedMessage} from "react-intl";
import {Category} from "@models/category";
import CategorySelection from "@components/categories/Selection";
import {SelectionMode} from '@models';

interface CategoryProps {
  selectedCategory: Category | null;
  form: any;
}

const WidgetItemCategorySelection: React.FC<CategoryProps> = props => {

  const {form, selectedCategory} = props;
  const [category, setCategory] = useState(selectedCategory || null);

  const onSelectCategory = (category: Category) => {
    setCategory(category)
    form.setFieldsValue({
      category: category,
      category_id: category.id,
    });
  };
  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("category", {
          initialValue: category
        })(
          <Input type={`hidden`}/>
        )}
      </Form.Item>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item label={<FormattedMessage id="app.select_category" defaultMessage={`Select Category`}/>}>
            {form.getFieldDecorator("category_id", {
              initialValue: category ? category.id : null,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.category_is_required"
                      defaultMessage={`Select category!`}
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <CategorySelection mode={SelectionMode.DEFAULT}
                               onChange={onSelectCategory}
                               initialValue={category}/>
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  )
};

export default WidgetItemCategorySelection;



